import { render, staticRenderFns } from "./MessageTefPixPaymentError.vue?vue&type=template&id=e22987e6&scoped=true&"
import script from "./MessageTefPixPaymentError.vue?vue&type=script&lang=js&"
export * from "./MessageTefPixPaymentError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22987e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e22987e6')) {
      api.createRecord('e22987e6', component.options)
    } else {
      api.reload('e22987e6', component.options)
    }
    module.hot.accept("./MessageTefPixPaymentError.vue?vue&type=template&id=e22987e6&scoped=true&", function () {
      api.rerender('e22987e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/pdv/pay-box/components/tabs/components/MessageTefPixPaymentError.vue"
export default component.exports